<microsec-loading-overlay [isLoading]="!!isLoading">
  <div class="flex flex-col gap-3 mt-2">
    <div class="flex flex-row items-center justify-between">
      <label class="font-bold text-md">Active Scan Progress</label>
      <span class="cursor-pointer" pTooltip="Close" tooltipPosition="right" appendTo="body" (click)="hidePanelEvent.emit()">
        <i class="pi pi-times"></i>
      </span>
      <!-- <label class="link" (click)="handleNewScanClick($event)">New Scan</label> -->
    </div>
    <div class="mt-0"><hr style="border-color: #999999; border-width: 0.5px; width: 100%" /></div>
    <div class="flex gap-3">
      <div class="flex w-8 grow-0 justify-center mt-auto mb-auto ml-3">
        @switch (scanStatus) {
          @case (ACTIVE_SCAN_STATUSES.RUNNING) {
            <i class="fa-xl fa-solid fa-circle-notch fa-spin"></i>
          }
          @case (ACTIVE_SCAN_STATUSES.PAUSED) {
            <i class="fa-xl fa-solid fa-tower-broadcast"></i>
          }
          @case (ACTIVE_SCAN_STATUSES.STOPPED) {
            <i class="fa-xl fa-solid fa-ban"></i>
          }
          @case (ACTIVE_SCAN_STATUSES.NOT_RUNNING) {
            <i class="fa-xl fa-solid fa-circle-check"></i>
          }
          @default {}
        }
      </div>
      <div class="flex grow">
        <div class="flex flex-col">
          <label class="mb-1">MicroIDS Scan</label>
          <label class="text-sm text-grey">{{ (scanStatus === ACTIVE_SCAN_STATUSES.NOT_RUNNING ? 'completed' : scanStatus) | titlecase }}</label>
        </div>
      </div>
      @if (permissions[USER_ROLE.TECHNICIAN]) {
        <div class="flex grow-0">
          <div class="flex flex-row justify-between gap-3">
            @switch (scanStatus) {
              @case (ACTIVE_SCAN_STATUSES.RUNNING) {
                <i class="fa-solid fa-pause icon-hover" pTooltip="pause scan" (click)="changeStatusEvent.emit(SCAN_ACTION_TYPES.PAUSE)"></i>
                <i class="fa-solid fa-circle-xmark icon-hover" pTooltip="cancel scan" (click)="changeStatusEvent.emit(SCAN_ACTION_TYPES.STOP)"></i>
              }
              @case (ACTIVE_SCAN_STATUSES.PAUSED) {
                <i class="fa-solid fa-play icon-hover" pTooltip="resume scan" (click)="changeStatusEvent.emit(SCAN_ACTION_TYPES.RESUME)"></i>
                <i class="fa-solid fa-circle-xmark icon-hover" pTooltip="cancel scan" (click)="changeStatusEvent.emit(SCAN_ACTION_TYPES.STOP)"></i>
              }
              @default {}
            }
          </div>
        </div>
      }
    </div>
    <!-- <div class="flex ml-auto mr-0">
      <p-button class="text-right" type="button" size="small" label="Close panel" severity="secondary" (click)="hidePanelEvent.emit()"></p-button>
    </div> -->
  </div>
</microsec-loading-overlay>
